// src/api/profitLoss.api.ts
import { get } from './client';

export const profitLossApi = {
  getProfitLoss: (startDate: string, endDate: string) =>
    get('/reports/profit-loss', { params: { startDate, endDate } }),
};
